import React, { ChangeEvent, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import config from './ConfigPath';
import { Mat, cvtColor, resize, INTER_LINEAR, Size, GaussianBlur, COLOR_BGR2RGBA, COLOR_GRAY2RGBA, COLOR_GRAY2BGR, COLOR_BGRA2GRAY, CV_8U, imread, minMaxLoc, Rect, Point, circle, LINE_AA, CV_16U, Scalar } from '@techstark/opencv-js';
import { generateCustomColormap } from "components/Modals/PatientModal/utils/colormapUtils";
import FrameProcessorPressure from "components/Modals/PatientModal/utils/FrameProcessorPressure";
import PressureRenderOptions from "./PressureRenderOptions";
import { PressureImage } from "models/Insole";

export interface RondonPressureViewerComponentHandler {
    // getRawFrameArray(): Mat[];
    // getColorizeMat(): PressureImage | undefined;
    getImageSrc(): string
}

interface RondonPressureViewerComponentProps {
    mode: Mode;
    imgData: ImageMatInput;
    // componentTitle: string;
}

type Mode = 'online' | 'viewer' | 'edit';
type ImageMatInput = Mat | undefined;

export function reverseImageData(imageData: ImageData): ImageData {
    const { width, height, data } = imageData;
    const newData = new Uint8ClampedArray(data.length);
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const srcIndex = (y * width + x) * 4;
            const destIndex = ((height - 1 - y) * width + (width - 1 - x)) * 4;

            newData[destIndex] = data[srcIndex];
            newData[destIndex + 1] = data[srcIndex + 1];
            newData[destIndex + 2] = data[srcIndex + 2];
            newData[destIndex + 3] = data[srcIndex + 3];
        }
    }

    return new ImageData(newData, width, height);
}

export function convertMatToImageData(imgMat: Mat): ImageData {
    let rgbaMat = new Mat();
    cvtColor(imgMat, rgbaMat, COLOR_BGR2RGBA);
    let imgData = new ImageData(new Uint8ClampedArray(rgbaMat.data), rgbaMat.cols, rgbaMat.rows);
    return imgData;
}

export function applyColorMap2(colorMap: [number, number, number][], srcMat: Mat): Mat {
    let dst = new Mat();
    // console.log(srcMat);
    cvtColor(srcMat, dst, COLOR_GRAY2RGBA);
    // console.log(srcMat);

    for (let r = 0; r < srcMat.rows; r++) {
        for (let c = 0; c < srcMat.cols; c++) {
            let pixelValue = srcMat.ucharAt(r, c);
            let color = colorMap[pixelValue];
            dst.ucharPtr(r, c)[0] = color[0]; //blue
            dst.ucharPtr(r, c)[1] = color[1]; //green
            dst.ucharPtr(r, c)[2] = color[2]; //red
            dst.ucharPtr(r, c)[3] = 255;
        }
    }
    return dst;
}

export function applyColorMap(colorMap: [number, number, number][], srcMat: Mat): Mat {
    let dst = new Mat();
    // console.log(srcMat);
    cvtColor(srcMat, dst, COLOR_GRAY2BGR);
    // console.log(srcMat);

    for (let r = 0; r < srcMat.rows; r++) {
        for (let c = 0; c < srcMat.cols; c++) {
            let pixelValue = srcMat.ucharAt(r, c);
            let color = colorMap[pixelValue];
            dst.ucharPtr(r, c)[0] = color[0]; //blue
            dst.ucharPtr(r, c)[1] = color[1]; //green
            dst.ucharPtr(r, c)[2] = color[2]; //red
        }
    }
    return dst;
}

const RondonPressureViewerComponent = forwardRef<RondonPressureViewerComponentHandler, RondonPressureViewerComponentProps>((
    { mode, imgData }, ref
) => {

    const colorMapCustom = useRef<[number, number, number][] | null>(null);
    const colorMapPrint = useRef<[number, number, number][] | null>(null);
    const rawFrameArray = useRef<Mat[]>([]);
    const rawFrameCOPs = useRef<Point[]>([]);
    const currentFrameIndex = useRef<number>(0);

    const frameProcessor = useRef<FrameProcessorPressure>(new FrameProcessorPressure());
    const renderOptions = useRef<PressureRenderOptions>(new PressureRenderOptions());
    const renderROI = useRef<Rect>(new Rect(0, 0, 44, 52));
    const renderRectangle = useRef<Rect>(new Rect(0, 0, 0, 0));
    const SSF = useRef<number>(10);

    const colorizeMat = useRef<ImageData | undefined>(undefined);

    const myCanvas = useRef(null);
    const [imageSrc, setImageSrc] = useState<string>('');
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    useImperativeHandle(ref, () => ({
        // getRawFrameArray: () => rawFrameArray.current,
        // getColorizeMat: () => {
        //     if (colorizeMat.current) {
        //         const pressureImage: PressureImage = {
        //             image: reverseImageData(colorizeMat.current),
        //             realWidth: (colorizeMat.current.width * 7.62 / 5),
        //             realHeight: (colorizeMat.current.height * 7.62 / 5)
        //         };
        //         return pressureImage;
        //     }
        //     return undefined;
        //     // return colorizeMat.current;
        // },
        getImageSrc: () => {
            return imageSrc;
        }
    }), [imageSrc]);

    // useEffect(() => {
    //     if (mode === 'online') {
    //         renderOptions.current.setOnlineMode();
    //     }
    //     else if (mode === 'viewer') {
    //         renderOptions.current.setViewerMode();
    //     }

    //     GenerateCustomColormap().then((colorMap) => {
    //         colorMapCustom.current = colorMap;
    //     });

    //     GeneratePrintColormap().then((colorMap) => {
    //         colorMapPrint.current = colorMap;
    //     });

    //     renderOptions.current.FullView = true;
    // }, []);

    // useEffect(() => {
    //     // if (imgData) {
    //     render(imgData);
    //     // }

    // }, [imgData]);

    // const GenerateCustomColormap = (): Promise<[number, number, number][]> => {
    //     return new Promise((resolve) => {
    //         ReadPalleteImage((im) => {
    //             const customLUT: [number, number, number][] = [];
    //             for (let i = 0; i < 256; i++) {
    //                 let color = im.ucharPtr(0, 255 - i);
    //                 let b = color[2];
    //                 let g = color[1];
    //                 let r = color[0];
    //                 customLUT.push([b, g, r]);
    //             }
    //             im.delete();
    //             resolve(customLUT);
    //         });
    //     });
    // };

    // const ReadPalleteImage = (callback: (im: Mat) => void): void => {
    //     // let img = new Image();
    //     // img.src = config.palleteImagePath;
    //     // img.crossOrigin = "Anonymous";

    //     // img.onload = function () {
    //     //     if (myCanvas.current) {

    //     //         myCanvas.current.width = img.width;
    //     //         myCanvas.current.height = img.height;
    //     //         let ctx = myCanvas.current.getContext("2d");
    //     //         if (!ctx) return;
    //     //         ctx.drawImage(img, 0, 0);

    //     //         let srcMat = imread(myCanvas.current);

    //     //         //Clear canvas after reading Palette
    //     //         ctx.clearRect(0, 0, myCanvas.current.width, myCanvas.current.height);

    //     //         callback(srcMat);
    //     //     };
    //     // }
    // };

    // const GeneratePrintColormap = (): Promise<[number, number, number][]> => {
    //     return new Promise((resolve) => {
    //         ReadPrintPalleteImage((im) => {
    //             const customLUT: [number, number, number][] = [];
    //             for (let i = 0; i < 256; i++) {
    //                 let color = im.ucharPtr(0, 255 - i);
    //                 let b = color[2];
    //                 let g = color[1];
    //                 let r = color[0];
    //                 customLUT.push([b, g, r]);
    //             }
    //             im.delete();
    //             resolve(customLUT);
    //         });
    //     });
    // };

    // const ReadPrintPalleteImage = (callback: (im: Mat) => void): void => {
    //     // let img = new Image();
    //     // img.src = config.palletePrintImagePath;
    //     // img.crossOrigin = "Anonymous";

    //     // img.onload = function () {
    //     //     if (myCanvas?.current) {
    //     //         myCanvas.current.width = img.width;
    //     //         myCanvas.current.height = img.height;
    //     //         let ctx = myCanvas.current.getContext("2d");
    //     //         if (!ctx) return;
    //     //         ctx.drawImage(img, 0, 0);

    //     //         let srcMat = imread(myCanvas.current);

    //     //         //Clear canvas after reading Palette
    //     //         ctx.clearRect(0, 0, myCanvas.current.width, myCanvas.current.height);

    //     //         callback(srcMat);
    //     //     }
    //     // };
    // };

    // const render = (mat: Mat | undefined) => {

    //     // let ctx = myCanvas.current.getContext("2d");
    //     // ctx.clearRect(0, 0, myCanvas.current.width, myCanvas.current.height);

    //     // if (!mat) return;
    //     // setRawFrame(mat);

    //     // let afterFilter = applyFilters(mat);

    //     // // if (mode === 'viewer' && renderOptions.current.Draw_COP) {
    //     // //     drawCOP(afterFilter);
    //     // // }

    //     // let imageData = convertMatToImageData(afterFilter[0]);
    //     // let printImagData = convertMatToImageData(afterFilter[1]);
    //     // colorizeMat.current = printImagData;
    //     // ctx.putImageData(imageData, 0, 0);
    //     // // resizeCanvasToFullSize();
    //     // // console.log('Image Render: ', imageData);
    // }

    // const setRawFrame = (mat: Mat) => {
    //     if (!(mat instanceof Mat)) {
    //         console.error("Invalid input: Expected cv.Mat instance.");
    //     }

    //     rawFrameArray.current.forEach(mat => mat.delete());
    //     rawFrameArray.current.length = 0;
    //     rawFrameCOPs.current = [];

    //     currentFrameIndex.current = 0;

    //     const copyMat = new Mat(mat);
    //     rawFrameArray.current.push(mat);

    //     if (renderOptions.current.FullView) renderROI.current = new Rect(0, 0, mat.cols, mat.rows);
    //     renderRectangle.current = getZoomRectangle(renderROI.current);

    //     if (mode === 'viewer') {
    //         rawFrameCOPs.current.push(frameProcessor.current.ComputeCOP(rawFrameArray.current[currentFrameIndex.current]));
    //     }
    // }

    // const getZoomRectangle = (roi: Rect): Rect => {
    //     const rect = myCanvas.current.getBoundingClientRect();
    //     const displayWidth = rect.width;
    //     const displayHeight = rect.height;

    //     // Update canvas dimensions to match display size
    //     myCanvas.current.width = displayWidth;
    //     myCanvas.current.height = displayHeight;

    //     const targetWidthRatio = 1;
    //     const targetHeightRatio = 1;

    //     const scaleX = (displayWidth * targetWidthRatio) / roi.width;
    //     const scaleY = (displayHeight * targetHeightRatio) / roi.height;

    //     SSF.current = Math.min(scaleX, scaleY);

    //     const newWidth = Math.round(SSF.current * roi.width);
    //     const newHeight = Math.round(SSF.current * roi.height);

    //     const locx = Math.round((displayWidth - newWidth) / 2.0);
    //     const locy = Math.round((displayHeight - newHeight) / 2.0);

    //     return new Rect(locx, locy, newWidth, newHeight);
    // }

    // const applyFilters = (src: Mat): Mat[] => {
    //     let normalize = Normalize(src);

    //     let dst5 = new Mat();
    //     const firstScaleFactor = 5;
    //     const dsize = new Size(src.cols * firstScaleFactor, src.rows * firstScaleFactor);
    //     resize(normalize, dst5, dsize, INTER_LINEAR);

    //     let dstBlur = new Mat();
    //     // let dstBlur2 = new Mat();
    //     GaussianBlur(dst5, dstBlur, new Size(5, 5), 1.4);
    //     // GaussianBlur(normalize, dstBlur2, new Size(5, 5), 1.4);

    //     let colorized = ApplyCustomColorMap(dstBlur);
    //     let printColorized = applyColorMap(colorMapPrint.current, dstBlur);

    //     let dstFinal1 = new Mat();
    //     // let dstFinal2 = new Mat();
    //     const finalScaleFactor = SSF.current;
    //     // const finalScaleFactor = 7.62;
    //     const finalDSize = new Size(src.cols * finalScaleFactor, src.rows * finalScaleFactor);
    //     // const finalDSize2 = new Size(src.cols, src.rows);
    //     resize(colorized, dstFinal1, finalDSize, INTER_LINEAR);
    //     // resize(printColorized, dstFinal2, finalDSize2, INTER_LINEAR);

    //     return [dstFinal1, printColorized];
    // }

    // const Normalize = (img: Mat): Mat => {
    //     let result = minMaxLoc(img);
    //     let maxVal = result.maxVal;
    //     // if (maxVal < 111) maxVal = 111;

    //     let normalize = new Mat();
    //     // const scaleValue = 0.1;
    //     // img.convertTo(normalize, CV_8U, scaleValue);
    //     img.convertTo(normalize, CV_8U, 255 / maxVal);
    //     return normalize;
    // }

    // const ApplyCustomColorMap = (srcMat: Mat): Mat => {
    //     let dst = new Mat();
    //     // console.log(srcMat);
    //     cvtColor(srcMat, dst, COLOR_GRAY2BGR);
    //     // console.log(srcMat);

    //     for (let r = 0; r < srcMat.rows; r++) {
    //         for (let c = 0; c < srcMat.cols; c++) {
    //             let pixelValue = srcMat.ucharAt(r, c);
    //             let color = colorMapCustom.current[pixelValue];
    //             dst.ucharPtr(r, c)[0] = color[0]; //blue
    //             dst.ucharPtr(r, c)[1] = color[1]; //green
    //             dst.ucharPtr(r, c)[2] = color[2]; //red
    //         }
    //     }
    //     return dst;
    // }

    // const drawCOP = (mat: Mat): void => {
    //     if (!mat || !rawFrameCOPs.current || rawFrameCOPs.current.length === 0) return;

    //     const cop = rawFrameCOPs.current[currentFrameIndex.current];
    //     const copRender = getRenderPoint(cop);
    //     if (!copRender) return;
    //     circle(
    //         mat,
    //         copRender,
    //         3,
    //         [204, 136, 0, 255],
    //         2,
    //         LINE_AA
    //     );
    // }

    // const getRenderPoint = (point: Point) => {
    //     if (!point) return null;

    //     const rect = myCanvas.current.getBoundingClientRect();
    //     const displayWidth = rect.width;
    //     const displayHeight = rect.height;

    //     const scaleX = displayWidth / renderROI.current.width;
    //     const scaleY = displayHeight / renderROI.current.height;
    //     const scale = Math.min(scaleX, scaleY);

    //     const x = (point.x - renderROI.current.x) * scale + renderRectangle.current.x;
    //     const y = (point.y - renderROI.current.y) * scale + renderRectangle.current.y;

    //     return new Point(x, y);
    // }

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const url = URL.createObjectURL(file);
        setImageSrc(url);
    }


    const styles = {
        mainContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
            gap: '2px',
            padding: '10px',
            // backgroundColor: '#aee0f5',
            backgroundColor: 'transparent',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        } as React.CSSProperties,

        paletteImage: {
            width: '100%',
            height: '10px',
            transform: 'rotate(180deg)',
            borderRadius: '4px 4px 0 0',
        } as React.CSSProperties,

        labelContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '4px 8px',
        } as React.CSSProperties,

        paletteLabel: {
            fontSize: '14px',
            color: '#0088CC',
            display: 'none',
        } as React.CSSProperties,

        bufferRead: {
            margin: '0',
            padding: '0',
            fontSize: '14px',
            color: '#0088CC',
        } as React.CSSProperties,

        bufferProcess: {
            margin: '0',
            padding: '0',
            fontSize: '14px',
            color: '#0088CC',
        } as React.CSSProperties,

        canvas: {
            width: "100%",
            height: "100%",
            objectFit: "contain",
        } as React.CSSProperties,

        canvasContainer: {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        } as React.CSSProperties,

        hiddenInputStyle: {
            display: 'none',
        } as React.CSSProperties,

        selectButton: {
        appearance: 'none',
        border: '#000',
        borderRadius: '4px',
        height: '36px',             
        padding: '6px 16px',         
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        color: '#000',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        } as React.CSSProperties,


        selectContainer: {
            gridColumn: '1 / span 2',
            // gridRow: '3',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            // margin: '5px 0'
            marginTop: '10px',
            marginBottom: '3px'
        } as React.CSSProperties,


        imageTitle: {
            maxHeight: '50px',
        } as React.CSSProperties,
    }

    const getBorderContainer = (): React.CSSProperties => ({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        visibility: (mode === 'viewer') ? 'hidden' : 'visible'
    });


    return (
        <div style={styles.mainContainer}>
            {/* <div style={getBorderContainer()}>
                <img style={styles.paletteImage} src={config.palleteImagePath} />

                <div style={styles.labelContainer}>
                    <span style={styles.paletteLabel}>1.1</span>
                </div>
            </div> */}
            {/* 
            {mode === 'edit' && <p id="bufferRead" style={styles.bufferRead}>Buffer Read: </p>}
            {mode === 'edit' && <p id="bufferProcess" style={styles.bufferProcess}>Frame Rate: </p>} */}

            {/* <div style={styles.canvasContainer}>
                <canvas id="canvas" ref={myCanvas} style={styles.canvas} />
            </div> */}
            {/* <h2 style={styles.imageTitle}>{componentTitle}</h2> */}
            <div style={styles.canvasContainer}>
                {imageSrc && <img id="canvas" ref={myCanvas} style={styles.canvas} alt="Uploaded" src={imageSrc} />}
            </div>
            <div style={styles.selectContainer}>
            <button
                type="button"
                style={styles.selectButton}
                onMouseEnter={(e) =>
                (e.currentTarget.style.color = '#0a6fb4')
                }
                onMouseLeave={(e) =>
                (e.currentTarget.style.color = '#000')
                }
                onClick={() => fileInputRef.current?.click()}
            >
                Select Image
            </button>

            <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={styles.hiddenInputStyle}
                onChange={handleFileChange}
            />
            </div>

        </div>
    );
});

export default RondonPressureViewerComponent;